<template>
  <div
    class="chat-messages"
    :class="{ dark }"
  >
    <div
      class="chat-messages__inner"
      :class="{ dark }"
    >
      <div
        v-for="message in messages"
        :key="message.id"
        class="chat-message drag-cancel"
        :class="{ dark }"
      >
        <HollowDotsSpinner
          v-if="message.loading"
          :animation-duration="1000"
          :dot-size="10"
          :dots-num="3"
          color="#256d92"
        />
        <template v-else>
          <span class="font-bold mr-2">{{ message.who }}:</span>
          <span>{{ message.text }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'ChatMessages',

  components: { HollowDotsSpinner },

  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),
  },
}
</script>

<style lang="postcss" scoped>
.chat {
  &-messages {
    @apply overflow-y-scroll border border-blue bg-blue-darkest;

    &.dark {
      @apply bg-almost-black;
    }

    &__inner {
      @apply h-full p-4;
    }
  }

  &-message {
    max-width: 300px;
    @apply px-4 py-2 text-sm text-blue-lighter w-full;

    &.dark {
      @apply text-blue font-bold;
    }
  }
}
</style>
